import React, { useState, useEffect } from 'react'
import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux'
import { CreatorsAnchors } from '../../../../store/ducks/anchors'

import api from '../../../../services/api'
import { getPermissions } from '../../../../services/auth'
import { useHistory } from 'react-router'

import Render from './RegisterRender'

function Register ({ ancoralojaid }) {
  const history = useHistory()

  const [inputs, setInputs] = useState({
    status: 'Ativo'
  })
  const [getErros, setErros] = useState([])

  const dispatch = useDispatch()

  const [getLoading, setLoading] = useState(false)

  const handleInputChange = (event) => {
    event.persist()
    setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }))
  }

  useEffect(() => {
    dispatch(CreatorsAnchors.changeLastGrid('ancoras-lojas-codigos'))

    const permissions = getPermissions({ moduloId: 1344, permissao: 'Cadastrar' })

    if (!permissions) {
      history.push('/app')
    }
  }, [])

  const handleSubmit = async (event) => {
    if (event) {
      event.preventDefault()
      setLoading(true)
      try {
        const response = await api.post('AncorasLojasCodigos', {
          ...inputs,
          ancoraLojaId: parseInt(ancoralojaid)
        })
        if (response.data.status !== 'Inconsistencia') {
          setInputs({})
          toast.success('Loja código adicionado com sucesso!')
        } else {
          if (response.data.resposta[0].key) {
            const errosArray = []

            response.data.resposta.map(resposta => {
              errosArray.push(resposta.key)

              toast.error(resposta.key + ' - ' + resposta.message)
              return null
            })

            setErros(errosArray)
          } else {
            toast.error('Não foi possível adicionar a nova loja código!')
          }
        }
      } catch (err) {
        if (err.response.data && err.response.data.resposta[0]) {
          toast.error(err.response.data.resposta[0].message)
        } else {
          toast.error('Detectamos um problema interno! tente novamente em instantes.')
        }
      }
      setLoading(false)
    }
  }

  return <Render
    inputs={inputs}
    getLoading={getLoading}
    handleInputChange={handleInputChange}
    getErros={getErros}
    setErros={setErros}
    onSubmit={handleSubmit}
  />
}

export default Register
